import {getLogger} from "@goodgamestudios/logger";

const logger = getLogger("Tracking.BasicTrackingEvent");

export class BasicTrackingEvent {
    constructor(protected referrer: string) {
    }

    public getVars(): Object {
        throw (new Error("TrackingEvent.getVars must be implemented by concrete classes"));
    }
}
